import type { LocationDescriptor } from 'history';
import type { HTMLAttributes } from 'react';

export interface ReviewsList {
  amount: number;
  average: number;
}
export interface CardItemProData {
  image?: string;
  name?: string;
  description?: string;
  languages?: string;
  services?: string[];
  location?: string;
  distance?: string;
  center?: string;
  hasBooking?: boolean;
  link?: LocationDescriptor;
  isUnclaimed?: boolean;
  loading?: boolean;
  reviewsList?: ReviewsList;
  lazyLoadImage?: boolean;
}

export interface CardItemProProps extends HTMLAttributes<HTMLDivElement>, CardItemProData {}
